export type GradeFactorDocumentType = "gfCharges" | "apUS" | "apCAD" | "arCAD" | "arUS";
export type TicketSegmentMap = { [key: string]: TicketSegment };

export interface TicketSegment {
  ticketNumber: string,
  commodity: string,
  entries: TicketSegmentLineItem[],
}

export interface TicketSegmentLineItem {
  document: GradeFactorDocumentType,
  documentVersion: "currentMonth" | "previousMonth",
  purchaseOrSales: "P" | "S",
  fullName: string,
  discount: number,
  reportedDiscount: number,
  _preConversionDiscount?: number, // This field is set if we are converting CAD to USD; for debug purposes only
}

export class TicketGroupBuilder {
  ticketsByCommodity: { [commodity: string]: TicketSegmentMap };

  constructor() {
    this.ticketsByCommodity = {};
  }

  getOrCreateTicketGroupForCommodity(commodityId: string): TicketSegmentMap {
    const key = `${commodityId}`.toUpperCase();
    if (!(key in this.ticketsByCommodity)) {
      this.ticketsByCommodity[key] = {

      }
    }

    return this.ticketsByCommodity[key];
  }

  getOrCreateTicketSegment(commodityId: string, ticketNumber: string | number) {
    const ticketGroup = this.getOrCreateTicketGroupForCommodity(commodityId);
    const key = `${ticketNumber}`;
    if (!(key in ticketGroup)) {
      ticketGroup[key] = {
        commodity: commodityId,
        ticketNumber: key,
        entries: [],
      }
    }

    return ticketGroup[key];
  }

  push(commodityId: string, ticketNumber: string | number, data: TicketSegmentLineItem) {
    const ticketSegment = this.getOrCreateTicketSegment(commodityId, ticketNumber);
    ticketSegment.entries.push(data);
  }
}
